export const tagThemeSmall = {
  padding: '2px 33px 4px 15px',
  fontSize: '13px',
  lineHeight: '1.43',
};
